import { CommApiInstance } from "Utils/CommApiInstance";

const FooterApi = async (
    gameSvcCd:string,
    
) => {
    return await CommApiInstance.post(`${gameSvcCd}/footer`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default FooterApi;